import { render, staticRenderFns } from "./c-porcentagem.vue?vue&type=template&id=0f1a4c64&scoped=true"
import script from "./c-porcentagem.vue?vue&type=script&lang=js"
export * from "./c-porcentagem.vue?vue&type=script&lang=js"
import style0 from "./c-porcentagem.vue?vue&type=style&index=0&id=0f1a4c64&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0f1a4c64",
  null
  
)

export default component.exports